import classNames from 'classnames';
import styles from './LinkButton.module.scss';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';
import type { LinkProps } from 'ui/components/1-atoms/Action/Link/Link';

export interface LinkButtonProps extends Omit<LinkProps, 'style'> {
	children: React.ReactNode;
	state?: 'inactive';
	style?: 'primary' | 'secondary' | 'tertiary' | 'inactive' | 'sm' | 'cta';
	className?: string;
}

export const UI_LinkButton = ({ children, style, className, state, ...props }: LinkButtonProps) => (
	<UI_Link className={classNames(styles.LinkButton, styles[`LinkButton___${style}`], styles[`LinkButton___${state}`], className)} {...props}>
		{children}
	</UI_Link>
);
